import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  FormHelperText,
} from '@mui/material';
import { Edit as EditIcon } from '@mui/icons-material';
import { CABO_PADROES_TUBO_LOOSE, PadraoTuboLoose } from '../../services/caboService';
import { getPadraoTuboLooseLabel } from '../../services/caboService';

interface DioEditPadraoModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (padrao_cores: PadraoTuboLoose) => void;
  padraoAtual?: PadraoTuboLoose;
  qtdePortas?: number;
  isFullscreen?: boolean;
  container?: HTMLElement | null;
}

const DioEditPadraoModal: React.FC<DioEditPadraoModalProps> = ({
  open,
  onClose,
  onConfirm,
  padraoAtual = 'abnt',
  qtdePortas = 12,
  isFullscreen = false,
  container,
}) => {
  const [padraoCores, setPadraoCores] = useState<PadraoTuboLoose>(padraoAtual);

  const menuZIndex = isFullscreen ? 10006 : 1600;
  const selectMenuProps = {
    MenuProps: { disablePortal: true, sx: { zIndex: menuZIndex } },
  };
  const selectFormControlSx = { '& .MuiPopover-root': { zIndex: menuZIndex } };

  useEffect(() => {
    if (open) {
      setPadraoCores(padraoAtual);
    }
  }, [open, padraoAtual]);

  const handleConfirm = () => {
    onConfirm(padraoCores);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      container={isFullscreen && container ? container : undefined}
      BackdropProps={{ sx: { backgroundColor: 'rgba(0, 0, 0, 0.7)', backdropFilter: 'blur(4px)' } }}
      sx={{ zIndex: isFullscreen ? 10005 : 1500 }}
    >
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <EditIcon sx={{ color: '#1976d2' }} />
          <Typography variant="h6" component="span" sx={{ fontSize: '1rem' }}>
            Editar padrão de cores do DIO
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          DIO com {qtdePortas} portas — altera apenas o padrão de cores das fibras (grupos de 12).
          Atual: <strong>{getPadraoTuboLooseLabel(padraoAtual)}</strong>
        </Typography>
        <FormControl fullWidth size="small" required sx={selectFormControlSx}>
          <InputLabel>Padrão de cores</InputLabel>
          <Select
            label="Padrão de cores"
            value={padraoCores}
            onChange={(e) => setPadraoCores(e.target.value as PadraoTuboLoose)}
            {...selectMenuProps}
          >
            {CABO_PADROES_TUBO_LOOSE.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
          <FormHelperText>ABNT ou EIA-598-A</FormHelperText>
        </FormControl>
      </DialogContent>
      <DialogActions sx={{ px: 2, pb: 2 }}>
        <Button onClick={onClose}>Cancelar</Button>
        <Button variant="contained" color="primary" onClick={handleConfirm}>
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DioEditPadraoModal;
